export const BUCKETS = [
    { key: 'brandstof', label: 'Brandstof', color: '#BCD4DA' },
    { key: 'laden', label: 'Laden', color: '#2A6085' },
    { key: 'parkeren', label: 'Parkeren', color: '#E0A943' },
    { key: 'wassen', label: 'Wassen', color: '#6E9AA5' },
    { key: 'onderhoud', label: 'Onderhoud', color: '#B0543B' },
    { key: 'overige', label: 'Overige', color: '#C9BBA8' },
];
/** Map any category label onto one of the dashboard groups (keyword-based). */
export function catToBucket(categorie) {
    const c = categorie.toLowerCase();
    if (/park/.test(c))
        return 'parkeren';
    if (/was/.test(c))
        return 'wassen';
    if (/onderhoud/.test(c))
        return 'onderhoud';
    if (/laden|electr|elektr|\bkwh\b/.test(c))
        return 'laden';
    if (/euro\s?9|super|benzine|diesel|brandstof|lpg|adblue/.test(c))
        return 'brandstof';
    return 'overige'; // antivries, smeermiddelen, pasfee, overige, unknown
}
//# sourceMappingURL=cost.js.map